import { render, staticRenderFns } from "./Top5Keywords.vue?vue&type=template&id=0c625228&scoped=true&"
import script from "./Top5Keywords.vue?vue&type=script&lang=js&"
export * from "./Top5Keywords.vue?vue&type=script&lang=js&"
import style0 from "./Top5Keywords.vue?vue&type=style&index=0&id=0c625228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c625228",
  null
  
)

export default component.exports